import { render, staticRenderFns } from "./PendingApprovalList.vue?vue&type=template&id=677d3dc2&lang=pug&"
import script from "./PendingApprovalList.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./PendingApprovalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports